import React, { useState, useEffect } from "react";

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // Carousel data
  const carouselItems = [
    {
      id: 1,
      image: "img/carousel-1.jpg",
      alt: "Online Learning Platform",
      // tagline: "Best Online Courses",
      // title: "The Best Online Learning Platform",
      description:
        "The object of education is to prepare the young to educate themselves throughout their lives.",
      author:
      "    -Robert M. Hutchins",
      // btnPrimaryText: "Read More",
      // btnSecondaryText: "Join Now",
    },
    {
      id: 2,
      image: "img/carousel-2.jpg",
      alt: "Online Education",
      tagline: "",
      title: "",
      description:
          "The object of education is to prepare the young to educate themselves throughout their lives.",
      author:
      "    - Robert M. Hutchins",
      // btnSecondaryText: "",
    },
  ];

  // Quick links data
  const quickLinks = [
    {
      id: 1,
      icon: "fa-graduation-cap",
      title: "Newsletter",
      link: "#",
      description: "Stay updated with college news",
    },
    {
      id: 2,
      icon: "fa-globe",
      title: "Online Registration",
      link: "#",
      description: "Register for courses online",
    },
    {
      id: 3,
      icon: "fa-download",
      title: "Download Application",
      link: "#",
      description: "Get application forms",
    },
    {
      id: 4,
      icon: "fa-comment-dots",
      title: "Feedback",
      link: "#",
      description: "Share your feedback with us",
    },
    {
      id: 5,
      icon: "fa-briefcase",
      title: "Careers",
      link: "#",
      description: "Explore career opportunities",
    },
  ];

  // Auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide]);

  const nextSlide = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
      setIsAnimating(false);
    }, 500);
  };

  const prevSlide = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentSlide(
        (prev) => (prev - 1 + carouselItems.length) % carouselItems.length
      );
      setIsAnimating(false);
    }, 500);
  };

  const goToSlide = (index) => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsAnimating(false);
    }, 500);
  };

  // Handle button clicks
  const handleButtonClick = (action) => {
    console.log(`${action} clicked`);
    // Add your navigation logic here
  };

  const handleQuickLinkClick = (title) => {
    console.log(`${title} clicked`);
    // Add your navigation logic here
  };

  return (
    <>
      {/* Custom Slider */}
      <div className="container-fluid p-0 mb-5">
        <div className="custom-slider position-relative">
          {carouselItems.map((item, index) => (
            <div
              key={item.id}
              className={`slider-item position-relative ${
                index === currentSlide ? "active" : ""
              }`}
              style={{ display: index === currentSlide ? "block" : "none" }}
            >
              <img
                className="img-fluid w-100"
                src={item.image}
                alt={item.alt}
                style={{ height: "600px", objectFit: "cover" }}
              />
              <div
                className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
                style={{ background: "rgba(24, 29, 56, .7)" }}
              >
                <div className="container">
                  <div className="row justify-content-start">
                    <div className="col-sm-10 col-lg-8">
                      <h5 className="text-primary text-uppercase mb-3 slide-in-down">
                        {item.tagline}
                      </h5>
                      <h1 className="display-3 text-white mb-4 slide-in-up">
                        {item.title}
                      </h1>
                      {/* <p className="fs-5 text-white mb-4 pb-2 slide-in-up-delay">
                        {item.description}<br/>
                        {item.author}
                      </p> */}
                      <p className="fs-5 text-white mb-4 pb-2 slide-in-up-delay">
                        {/* {item.author} */}
                      </p>
                      <div className="d-flex flex-wrap gap-3">
                        {/* <button
                          className="btn btn-primary py-md-3 px-md-5 me-3 slide-in-left"
                          onClick={() => handleButtonClick(item.btnPrimaryText)}
                        >
                          {item.btnPrimaryText}
                        </button> */}
                        {/* <button
                          className="btn btn-light py-md-3 px-md-5 slide-in-right"
                          onClick={() =>
                            handleButtonClick(item.btnSecondaryText)
                          }
                        >
                          {item.btnSecondaryText}
                        </button> */}
                        
                      </div>
                    </div>
                    <p className="fs-5 text-white mb-4 pb-2 slide-in-up-delay">
                        {item.description}<br/>
                        {item.author}
                      </p>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* Navigation Buttons */}
          <button className="slider-prev" onClick={prevSlide}>
            <i className="fas fa-chevron-left"></i>
          </button>
          <button className="slider-next" onClick={nextSlide}>
            <i className="fas fa-chevron-right"></i>
          </button>

          {/* Pagination Dots */}
          <div className="slider-dots">
            {carouselItems.map((_, index) => (
              <button
                key={index}
                className={`slider-dot ${
                  index === currentSlide ? "active" : ""
                }`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>


     <div className="d-flex align-items-center justify-content-center gap-3 my-4">
  <img 
    src="img/uni.svg" 
    alt="University of Mysore Logo" 
    className="img-fluid"
    style={{ maxWidth: '50px' }}
  />
  <h5 className="mb-0">Affiliated By University Of Mysore</h5>
</div>
      
      {/* Logo Image */}
      


      {/* Quick Links Section */}


        <div className="">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
            </h6>
            <h1 className="mb-5">Access Important Resources</h1>
          </div>          
        </div>
      

      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-4">
            <div
              className="col-lg-2 col-sm-6 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              <div className="service-item2 text-center pt-3">
                <div className="p-4" >
                  <i className="fa fa-3x fa-graduation-cap  mb-4" style={{color:"white"}}></i>
                  <h5 className="mb-3" style={{color:"white"}}>Newsletter</h5>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-sm-6 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              <div className="service-item3 text-center pt-3">
                <div className="p-4">
                  <i className="fa fa-3x fa-globe  mb-4"style={{color:"white"}}></i>
                  <h5 className="mb-3" style={{color:"white"}}>Online Registeration</h5>
                </div>
              </div>
            </div>
            <div
              className="col-lg-3 col-sm-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="service-item text-center pt-3">
                <div className="p-4">
                  <i className="fa fa-3x fa-download  mb-4" style={{color:"White"}}></i>
                  <h5 className="mb-3" style={{color:"white"}}>Download Application</h5>
                </div>
              </div>
            </div>
            <div
              className="col-lg-2 col-sm-6 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <div className="service-item4 text-center pt-3">
                <div className="p-4">
                  <i className="fa fa-3x fa-comment  mb-4" style={{color:"white"}}></i>
                  <h5 className="mb-3" style={{color:"white"}}>Feedback</h5>
                </div>
              </div>
            </div>
            <div
              className="col-lg-2 col-sm-6 wow fadeInUp"
              data-wow-delay="0.7s"
            >
              <div className="service-item5 text-center pt-3">
                <div className="p-4">
                  <i className="fa fa-3x fa-briefcase  mb-4" style={{color:"white"}}></i>
                  <h5 className="mb-3" style={{color:"white"}}>Careers</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: "400px" }}
            >
              <div className="position-relative h-100">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                  src="img/about.jpg"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h6 className="section-title bg-white text-start text-primary pe-3"></h6>
              <h1 className="mb-4">Welcome to M.C.M First Grade College</h1>
              <p className="mb-4">
                At M.C.M First Grade College Mysore, we stress on thorough
                understanding of business concepts. Along with that we create an
                environment of camaraderie and an atmosphere of mutual support
                and learning. We do our best to create business leaders who can
                stand alone but are equally effective and comfortable to work in
                teams' efforts and in diversity of situations. In our campus
                students understand the need of the society with a clear mind
                and a compassionate heart.
              </p>
              <p className="mb-4">
                M.C.M College has been under University of Mysore affiliation
                since 2012. For this I owe indebtedness to the chairman and all
                member of management Staff & Students of this college. May I
                hope that the academic standard of the students, dedication of
                the staff and above all Co-operation of the people of the
                locality be activated so that the reputation of the alma-meters
                be held in high esteem in future.
              </p>
              <p className="mb-4">
                Degree (+3) Honours /Pass Courses in Commerce under the UOM, to
                which it is affiliated.
              </p>
              <p className="mb-4">
                We welcome all those from student community with a vision for
                the future.
              </p>
              <a className="btn btn-primary py-3 px-5 mt-2" href="#">
                <i className="fa fa-envelope "></i> Message from Chairman
              </a>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .custom-slider {
          overflow: hidden;
        }

        .slider-item {
          transition: opacity 0.5s ease;
        }

        .slider-item.active {
          opacity: 1;
        }

        .slider-prev,
        .slider-next {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(0, 0, 0, 0.5);
          color: white;
          border: none;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 10;
          transition: all 0.3s ease;
        }

        .slider-prev:hover,
        .slider-next:hover {
          background: rgba(0, 0, 0, 0.8);
        }

        .slider-prev {
          left: 20px;
        }

        .slider-next {
          right: 20px;
        }

        .slider-dots {
          position: absolute;
          bottom: 20px;
          left: 0;
          right: 0;
          display: flex;
          justify-content: center;
          gap: 10px;
          z-index: 10;
        }

        .slider-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: none;
          background: rgba(255, 255, 255, 0.5);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .slider-dot.active {
          background: white;
          transform: scale(1.3);
        }

        .slider-dot:hover {
          background: white;
        }

        /* Animation classes */
        .slide-in-down {
          animation: slideDown 1s ease;
        }

        .slide-in-up {
          animation: slideUp 1s ease 0.3s both;
        }

        .slide-in-up-delay {
          animation: slideUp 1s ease 0.5s both;
        }

        .slide-in-left {
          animation: slideLeft 1s ease 0.7s both;
        }

        .slide-in-right {
          animation: slideRight 1s ease 0.7s both;
        }

        /* Hover effects */
        .hover-lift {
          transition: all 0.3s ease;
        }

        .hover-lift:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }

        .service-item {
          transition: all 0.3s ease;
          border: 1px solid #e9ecef;
          border-radius: 8px;
        }

        .service-item:hover {
          border-color: #4e73df;
        }

        .icon-wrapper {
          width: 80px;
          height: 80px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: rgba(78, 115, 223, 0.1);
        }

        .feature-item,
        .testimonial-item {
          transition: all 0.3s ease;
        }

        .feature-item:hover,
        .testimonial-item:hover {
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        @keyframes slideDown {
          from {
            transform: translateY(-50px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            transform: translateY(50px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes slideLeft {
          from {
            transform: translateX(-50px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes slideRight {
          from {
            transform: translateX(50px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
};
export default Home;
